import React, { useState, useEffect } from 'react';
import RestaurantMap from './ReataurantMap';
import locationsMetadata from './locationsData';

export default function LocationsView({shops}) {
    if (!shops) {
      return null
    }
    console.log(shops)
    const combinedLocations = locationsMetadata.map((location) => {
        const matchingShop = shops.find(shop => shop.shopId === location.id);
        if (matchingShop) {
            const addressComps = matchingShop.deliveryAddress.split(',')

            return(
              Object.assign({}, location, {
                address: [addressComps[0], addressComps[1] + addressComps[2]],
                phone: matchingShop.restuarantPhone,
                phoneLink: "+1" + matchingShop.restuarantPhone.replace(/[^0-9]/g, ''),
              })
            )
        }
        return location;
    })

    return(
      <div id="pick-locations" role="main" aria-labelledby="location-header">

       
      
    <RestaurantMap />
    <div className="location-list">{combinedLocations.map(({id, disabled, buttonLabel, openingDate, label, address, phone, hours, phoneLink, orderLink, className="", external, storefrontPhoto, lat, lng}) => (
      <div key={id} className={"grid-item location " + className}>
      <div className="location-content-wrapper">
      <div className="location-list-content">
        <h3 className="title">{label}</h3>


        


       
        
        {!disabled && <div className="loc-menu-link">
        <a href={orderLink} 
        aria-label={`Order Pickup or Delivery for ${label} location at ${address[0]}, ${address[1]}`}
        className="menu-location-link">
        <span className="menu-button">Order Pickup / Delivery</span></a>

        <span className="separator">
        ·
        </span>
        <a 
        aria-label={`Menu for ${label} location at ${address[0]}, ${address[1]}`}
        href={orderLink} className="menu-location-link"><span className="menu-button">{"Menu"}</span></a>
        </div>}

       
        <div className="address">
        {address[0]} <br/>
        {address[1]}
        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
          <a 
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address[0] + ', ' + address[1])}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${label} in Google Maps`}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: 'inherit', textDecoration: 'none', fontSize: '0.85rem', opacity: 0.8 }}
          >
            <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            Google Maps
          </a>
          <a 
            href={`https://maps.apple.com/?ll=${lat},${lng}&q=${encodeURIComponent(address[0] + ', ' + address[1])}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${label} in Apple Maps`}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: 'inherit', textDecoration: 'none', fontSize: '0.85rem', opacity: 0.8 }}
          >
            <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 1.74.5 3.37 1.41 4.84.95 1.54 2.2 2.86 3.16 4.4.47.75.81 1.45 1.17 2.26.26.55.47 1.5 1.26 1.5s1-.95 1.26-1.5c.36-.81.7-1.51 1.17-2.26.96-1.54 2.21-2.86 3.16-4.4C18.5 12.37 19 10.74 19 9c0-3.87-3.13-7-7-7zm0 9.75c-1.52 0-2.75-1.23-2.75-2.75S10.48 6.25 12 6.25s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75z"/>
            </svg>
            Apple Maps
          </a>
        </div>
        </div>
        <div className="phone">
        <a
        className="phone-link"
        href={`tel:${phoneLink}`}>{phone}</a>
        </div>
        <ul className="hours-of-operation" style={{
          listStyle: 'none',
          padding: 0,
          margin: '1rem 0',
          display: 'grid',
          gap: '0.25rem'
        }}>
        {hours.map((hour) => {
        return (<li key={hour.day} style={{
          display: 'grid',
          gridTemplateColumns: '150px 1fr',
          gap: '0.5rem',
          alignItems: 'baseline'
        }}>
        <span style={{ fontWeight: 500 }}>{hour.day}</span>
        <span style={{ opacity: 0.85 }}>{hour.hours}</span>
        </li>)
        })}
        </ul>

       
      </div>
      {storefrontPhoto && (
            <img 
              src={storefrontPhoto} 
              alt={`${label} storefront`}
              className="location-photo"
            />
          )}
      </div>
      </div>
    ))}
    </div>
    

    </div>  

    )
}